import Vue from 'vue'
import Router from 'vue-router'

// import login from '../views/user/login.vue'
// import index from '../views/index.vue'
// import mission from '../views/mission/show.vue'
// import user from '../views/user/user.vue'
// import set from '../views/user/set.vue'
// import add from '../views/mission/add.vue'
// import edit from '../views/mission/edit.vue'
// import notFound from '../views/notFound.vue'
import store from '../store/index'
import types from "../store/types.js";

Vue.use(Router)

const router = new Router({
    routes: [{
            path: '/',
            name: 'login',
            component: resolve => require(['../views/user/login.vue'], resolve),
            beforeEnter: (to, from, next) => {
                let token = window.sessionStorage.getItem('token');
                if (token !== null) {
                    next('/index');
                } else {
                    next();
                }
            }
        }, {
            path: '/index',
            name: 'index',
            component: resolve => require(['../views/index.vue'], resolve),
            meta: {
                requiresAuth: true
            }
        }, {
            path: '/mission/show',
            name: 'missionShow',
            component: resolve => require(['../views/mission/show.vue'], resolve),
            meta: {
                requiresAuth: true,
                isAdmin: 1
            }
        }, {
            path: '/user',
            name: 'user',
            component: resolve => require(['../views/user/user.vue'], resolve),
            meta: {
                requiresAuth: true,
                isAdmin: 1
            }
        }, {
            path: '/set',
            name: 'set',
            component: resolve => require(['../views/user/set.vue'], resolve),
            meta: {
                requiresAuth: true
            }
        }, {
            path: '/mission/add',
            name: 'missionAdd',
            component: resolve => require(['../views/mission/add.vue'], resolve),
            meta: {
                requiresAuth: true,
                isAdmin: 1
            }
        }, {
            path: '/mission/edit',
            name: 'missionEdit',
            component: resolve => require(['../views/mission/edit.vue'], resolve),
            meta: {
                requiresAuth: true,
                isAdmin: 0
            }
        },
        {
            path: '/common',
            name: 'common',
            component: resolve => require(['../views/common/common.vue'], resolve),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/common/add',
            name: 'commonAdd',
            component: resolve => require(['../views/common/add.vue'], resolve),
            meta: {
                requiresAuth: true,
                isAdmin: 1
            }
        },
        {
            path: '/common/show',
            name: 'commonShow',
            component: resolve => require(['../views/common/show.vue'], resolve),
            meta: {
                requiresAuth: true,
                isAdmin: 1
            }
        }, {
            path: '/common/edit',
            name: 'commonEdit',
            component: resolve => require(['../views/common/edit.vue'], resolve),
            meta: {
                requiresAuth: true,
                isAdmin: 0
            }
        }, {
            path: '/notFound',
            name: 'notFound',
            component: resolve => require(['../views/notFound.vue'], resolve)
        },
        {
            path:'/message',
            name:"message",
            component:resolve=>require(['../views/message/show.vue'],resolve),
            meta:{
                requiresAuth:true,
            }
        },
        {
            path: "*", // 此处需特别注意置于最底部
            redirect: "/notFound"
        }
    ]
})

router.beforeEach((to, from, next) => {
    //判断要去的路由有没有requiresAuth
    const isAdmin = parseInt(window.sessionStorage.getItem('isAdmin'));
    const token = window.sessionStorage.getItem('token');
    if (to.meta.requiresAuth) {
        if (token === null) {
            next({
                path: '/',
                query: { redirect: to.fullPath }
            })
        } else {
            if (to.meta.isAdmin != undefined) {
                if (isAdmin == to.meta.isAdmin) {
                    next()
                } else {
                    next({
                        path: '/notFound'
                    })
                }
            } else {
                next();
            }
        }
    } else {
        next();
    }

    
        if(to.path=="/index"){
            store.commit(types.CLEARMESSAGE,[])
            // window.sessi onStorage.removeItem('store')
        }
    
})

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
        // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
        location.reload();
        // const targetPath = $router.history.pending.fullPath;
        // $router.replace(targetPath);
    }
});

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }

export default router


// WEBPACK FOOTER //
// ./src/router/index.js